// extracted by mini-css-extract-plugin
export default {"paper":"_1MlQuHFmj0390Ul1oQPpee","inputContainer":"_3ziM6zV6kmESqNR7Vqfi2y","withIcon":"_3sN0eSFz3nvVPmViX9j4RO","inputIcon":"_3edH8o7tcCXyQZ62aPx_DI"};